export default __webpack_public_path__ + "static/media/boost_converter_nmos.f42e43f9.svg";